import { render, staticRenderFns } from "./item_from.vue?vue&type=template&id=048df5ff"
import script from "./item_from.vue?vue&type=script&lang=js"
export * from "./item_from.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports